export const projectFragment = /* GraphQL */ `
  fragment projectItem on Project {
    id
    name
    type
    description
    picture
    startDate
    endDate
    preferences
    actualSiteTimeInsertionMinutes
    actualSiteTimeClassicMinutes
    progress
    userProjectsId
    members(filter: { status: { ne: "ARCHIVED" } }) {
      items {
        id
        email
        role
        invitationDetails
        member {
          id
          name
          email
        }
        userID
        createdAt
        updatedAt
        status
        type
        shopManager
      }
    }
    place {
      id
      name
      address
      city
      zipcode
      country
      type
      location {
        lat
        lon
      }
    }
    blueprints {
      items {
        id
        name
        imageUrl
        project {
          id
          name
        }
      }
    }
    organizationID
    updatedAt
    createdAt
    organizationID
  }
`
